import React, { FC } from "react";
import { CalendarViewMode } from "../types";

interface ViewModeOption {
  label: string;
  value: CalendarViewMode;
}

interface ViewModeToggleProps {
  viewMode: CalendarViewMode;
  options: ViewModeOption[];
  onChange: (mode: CalendarViewMode) => void;
  className?: string;
}

export const ViewModeToggle: FC<ViewModeToggleProps> = ({
  viewMode,
  options,
  onChange,
  className = "",
}) => (
  <div
    className={`flex bg-slate-800 rounded-full overflow-hidden shadow-sm w-fit ${className}`}
  >
    {options.map((option) => (
      <button
        type="button"
        key={option.value}
        onClick={() => onChange(option.value)}
        className={`px-4 py-1 text-sm font-semibold transition-colors duration-200 ${
          viewMode === option.value
            ? "bg-slate-700 text-white"
            : "text-slate-300 hover:bg-slate-700/50"
        }`}
      >
        {option.label}
      </button>
    ))}
  </div>
);
